/* Superbotanic site script, loaded through the head key of nbd-config. */
(() => {

  /* Hide accordions whose metafield title is empty */
  const handleEmptyMetafields = () => {
    document.querySelectorAll('.accordion__wrapper').forEach(wrapper => {
      if (wrapper.querySelector('button')?.textContent.trim() === '') {
        wrapper.classList.add('is_empty');
      }
    });
  };

  /* Hide Pipeline's add to cart popdown and open the cart drawer instead */
  const disablePopdown = () => {
    const popdown = document.querySelector('[data-product-add-popdown-wrapper]');
    const cartDrawer = document.querySelector('#drawer-cart');
    if (!popdown || !cartDrawer) return;

    popdown.style.display = 'none';

    const refreshDrawer = () => {
      cartDrawer.dispatchEvent(
        new CustomEvent('theme:cart:reload', {
          bubbles: true
        })
      );
    };

    const openDrawer = () => {
      cartDrawer.dispatchEvent(
        new CustomEvent('theme:drawer:open', {
          bubbles: false,
        })
      );
    };

    document.addEventListener('theme:cart:popdown', () => {
      openDrawer();
      refreshDrawer();
    });

    // nbd-cart-watcher.js emits nbd:cart-changed after any later cart request.
    document.addEventListener('theme:cart:popdown', () => {
      window.addEventListener('nbd:cart-changed', refreshDrawer);
    }, { once: true });
  };

  const init = () => {
    handleEmptyMetafields();
    disablePopdown();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
